module.exports = __webpack_public_path__ + "media/images/landing/illustration-glare-aad16ec3b36285c5de3fc74dbf449f1c.svg";